module.exports = __webpack_public_path__ + "static/media/wireframing_img2.42f93b71.png";